import React, { Component } from 'react';
import Panel from './../components/panel';
import { connect } from 'react-redux';

class Panels extends Component {
	renderList() {
		return this.props.panels.map((panel, i) => {
			return <Panel key={i} panelContent={panel.panelContent} />;
		});
	}
	render() {
		return <div>{this.renderList()}</div>;
	}
}

function mapStateToProps(state) {
	return {
		panels: state.panels
	};
}

export default connect(mapStateToProps)(Panels);



// WEBPACK FOOTER //
// ./src/containers/panels.js